<template>
  <div class="mx-auto max-w-3xl space-y-8 pb-4">
    <header>
      <h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ t('landing.how_to_app.title') }}
      </h1>
    </header>
    <div
      class="rounded-2xl border border-dashed border-gray-200 bg-gray-50/80 p-6 text-center text-gray-600 sm:p-8"
    >
      {{ t('landing.how_to_app.placeholder') }}
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

useHead(() => ({
  title: t('landing.how_to_app.meta_title'),
  meta: [{ name: 'description', content: t('landing.how_to_app.meta_description') }],
}))
</script>
